import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import { ProvidersResponseData } from 'src/api/common/lists/lists-api'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export const providersAtom = createPrimitiveAtom<
  Record<string, ProvidersResponseData>
>({})

export async function updateProviderssAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().listsApi.getProviders()
  const record = indexBy(x => x.name, data)
  dispatch(providersAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}
